import { useLang } from "@/hooks/use-lang";

const TRAVEL_TYPES = [
  { key: "relax", emoji: "🧘", fr: "Détente", en: "Relaxation" },
  { key: "adventure", emoji: "🏔️", fr: "Aventure", en: "Adventure" },
  { key: "culture", emoji: "🏛️", fr: "Culture", en: "Culture" },
  { key: "mixed", emoji: "🌍", fr: "Mixte", en: "Mixed" },
] as const;

interface TravelTypePickerProps {
  onSelect: (type: string) => void;
}

const TravelTypePicker = ({ onSelect }: TravelTypePickerProps) => {
  const { lang } = useLang();

  return (
    <div className="w-full max-w-xs mx-auto mt-2">
      <p className="text-sm text-muted-foreground text-center mb-4">
        {lang === "fr"
          ? "Quel type de voyage te fait envie ?"
          : "What type of trip are you looking for?"}
      </p>
      <div className="grid grid-cols-2 gap-3">
        {TRAVEL_TYPES.map((t) => (
          <button
            key={t.key}
            onClick={() => onSelect(lang === "fr" ? t.fr : t.en)}
            className="flex flex-col items-center justify-center gap-1.5 py-4 px-3 rounded-2xl bg-background/60 backdrop-blur-xl border border-border/30 shadow-md hover:bg-background/80 hover:shadow-lg hover:-translate-y-0.5 active:scale-95 transition-all duration-200 text-foreground"
          >
            <span className="text-2xl">{t.emoji}</span>
            <span className="text-xs font-semibold">{lang === "fr" ? t.fr : t.en}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TravelTypePicker;
